import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Roles } from 'src/app/models/domain';
import { SessionService } from 'src/app/state';

@Directive({
  selector: '[emVisibleForRoles]',
  standalone: false,
})
export class VisibleForRolesDirective implements OnInit, OnDestroy {
  @Input() public emVisibleForRoles: string[] = [];

  private readonly subscriptions = new Subscription();
  private isVisible = false;

  public constructor(
    private readonly viewContainerRef: ViewContainerRef,
    private readonly templateRef: TemplateRef<unknown>,
    private readonly sessionService: SessionService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.sessionService.role$.subscribe((currentRole) => {
        // Admin is added so that admins have all views visible without the need to explicitly add Admin
        const visibleForRoles = [...this.emVisibleForRoles, 'Admin', Roles.ViewAll];

        const shouldBeVisible = visibleForRoles.some(
          (visibleForRole) => visibleForRole === currentRole
        );

        if (shouldBeVisible && !this.isVisible) {
          this.show();
        } else if (!shouldBeVisible && this.isVisible) {
          this.hide();
        }
      })
    );
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private show() {
    this.isVisible = true;
    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }

  private hide() {
    this.isVisible = false;
    this.viewContainerRef.clear();
  }
}
